<template>
  <span>
    <div class="row f-row justify-content-center" style="padding: 0 8px 0 8px">
      <div class="col col-12" style="height: 100%; overflow: auto;">
        <table class="table table-sm table-borderless todo_table mt-1">
          <thead class="table-headers text-center align-center thead">
            <tr>
              <th style="width: 60px">SELECT</th>
              <th>COMPANY</th>
              <th v-if="!quoteSelectedBool">CLIENT</th>
              <th colspan="2">STRATEGY</th>
              <th v-if="!quoteSelectedBool">NOTIONAL</th>
              <th>RFQ ACCEPTED</th>
              <th>QUOTE SENT</th>
              <th>ORDER ACCEPTED</th>
              <th>EXECUTED</th>
              <th>CONFIRMED</th>
              <th>REQUIRED ACTION</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
    <div class="row f-row justify-content-center" style="padding: 0 8px 0 8px">
      <div class="col col-12" style="height: 100%; overflow: auto;">
        <table class="table table-sm table-borderless todo_table">
          <tbody class="table-headers text-center align-center thead">
            <tr v-for="(item, index) in newQuotes" :key="index">
              <td
                style="width: 60px"
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
              >
                <label
                  :for="item.quoteId + '_button'"
                  class="toggle__button_g"
                  style="height: 100%; margin: auto !important;"
                  :class="{ actives: item.show }"
                >
                  <input
                    type="checkbox"
                    @click="onUserChangeQuote(item)"
                    :id="item.quoteId + '_button'"
                    v-model="item.show"
                  />
                  <span class="toggle__switch_g"></span>
                </label>
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
              >
                {{ item.company }}
              </td>
              <td
                v-if="!quoteSelectedBool"
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
              >
                {{ item.client }}
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
                colspan="2"
              >
                {{ item.strategy }}
              </td>
              <td
                v-if="!quoteSelectedBool"
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
              >
                {{ item.notional | formatM }}
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
              >
                <span
                  style="border: none!important;"
                  v-bind:class="[
                    item.state >= 1 ? 'h-line-expo' : 'h-line-gray'
                  ]"
                  >&nbsp;</span
                >
                <v-progress-circular
                  :indeterminate="animate && item.state === 0"
                  :value="95"
                  :rotate="5"
                  :color="
                    getColor(item.state + animate * 10 * (item.state === 0), 1)
                  "
                  :size="25"
                  :width="3"
                >
                  <i class="fa fa-times fnt-sm" v-show="item.state === -1"></i>
                  <i class="fa fa-check fnt-sm" v-show="item.state >= 1"></i>
                </v-progress-circular>
                <span
                  v-bind:class="[
                    item.state >= 1 ? 'h-line-expo' : 'h-line-gray'
                  ]"
                  >&nbsp;</span
                >
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
              >
                <span
                  v-bind:class="[
                    item.state >= 1 ? 'h-line-expo' : 'h-line-gray'
                  ]"
                  >&nbsp;</span
                >
                <v-progress-circular
                  :indeterminate="animate && item.state === 1"
                  :value="95"
                  :rotate="5"
                  :color="
                    getColor(item.state + animate * 10 * (item.state === 1), 2)
                  "
                  :size="25"
                  :width="3"
                >
                  <i class="fa fa-times fnt-sm" v-show="item.state === -1"></i>
                  <i class="fa fa-check fnt-sm" v-show="item.state >= 2"></i>
                </v-progress-circular>
                <span
                  v-bind:class="[
                    item.state >= 2 ? 'h-line-expo' : 'h-line-gray'
                  ]"
                  >&nbsp;</span
                >
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
              >
                <span
                  v-bind:class="[
                    item.state >= 2 ? 'h-line-expo' : 'h-line-gray'
                  ]"
                  >&nbsp;</span
                >
                <v-progress-circular
                  :indeterminate="animate && item.state === 2"
                  :value="95"
                  :rotate="5"
                  :color="
                    getColor(item.state + animate * 10 * (item.state === 2), 3)
                  "
                  :size="25"
                  :width="3"
                >
                  <i class="fa fa-times fnt-sm" v-show="item.state === -1"></i>
                  <i class="fa fa-check fnt-sm" v-show="item.state >= 3"></i>
                </v-progress-circular>
                <span
                  v-bind:class="[
                    item.state >= 3 ? 'h-line-expo' : 'h-line-gray'
                  ]"
                  >&nbsp;</span
                >
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
              >
                <span
                  v-bind:class="[
                    item.state >= 3 ? 'h-line-expo' : 'h-line-gray'
                  ]"
                  >&nbsp;</span
                >
                <v-progress-circular
                  :indeterminate="animate && item.state === 2"
                  :value="95"
                  :rotate="5"
                  :color="
                    getColor(item.state + animate * 10 * (item.state === 2), 4)
                  "
                  :size="25"
                  :width="3"
                >
                  <i class="fa fa-times fnt-sm" v-show="item.state === -1"></i>
                  <i class="fa fa-check fnt-sm" v-show="item.state >= 4"></i>
                </v-progress-circular>
                <span
                  v-bind:class="[
                    item.state >= 4 ? 'h-line-expo' : 'h-line-gray'
                  ]"
                  >&nbsp;</span
                >
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
              >
                <span
                  v-bind:class="[
                    item.state >= 4 ? 'h-line-expo' : 'h-line-gray'
                  ]"
                  >&nbsp;</span
                >
                <v-progress-circular
                  :indeterminate="animate && item.state === 2"
                  :value="95"
                  :rotate="5"
                  :color="
                    getColor(item.state + animate * 10 * (item.state === 2), 5)
                  "
                  :size="25"
                  :width="3"
                >
                  <i class="fa fa-times fnt-sm" v-show="item.state === -1"></i>
                  <i class="fa fa-check fnt-sm" v-show="item.state >= 5"></i>
                </v-progress-circular>
                <span
                  v-bind:class="[
                    item.state >= 5 ? 'h-line-expo' : 'h-line-gray'
                  ]"
                  >&nbsp;</span
                >
              </td>
              <td
                v-bind:class="{ 'row-hover': highlightRow === index }"
                @mouseover="onHoverRow(index)"
                @mouseleave="onHoverRow(-1)"
                @click="onUserChangeQuote(item)"
              >
                {{ item.action }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </span>
</template>

<script>
import { format } from "d3";
import { colorExpo, lightBackground } from "@/_core/_helpers/_parametric_tools";

export default {
  name: "QuotesList",
  props: {
    quotes: { required: true, default: () => [] },
    quoteSelectedBool: { required: true, type: Boolean, default: false }
  },
  data() {
    return {
      newQuotes: [],
      highlightRow: -1,
      animate: false
    };
  },
  computed: {},
  mounted() {
    this.newQuotes = this.quotes;
  },
  watch: {
    quotes() {
      this.newQuotes = this.quotes;
    }
  },
  methods: {
    getColor(num, ref) {
      return num >= ref ? colorExpo : lightBackground;
    },
    onHoverRow(idx) {
      this.highlightRow = idx;
    },
    onUserChangeQuote(item) {
      this.newQuotes.forEach(function(d) {
        if (item.quoteId !== d.quoteId) {
          d.show = false;
        } else {
          d.show = !d.show;
        }
      });
      this.$emit("eventOnUserChangeQuote", this.newQuotes);
    }
  },
  filters: {
    formatM: function(val) {
      return val === null || val === 0 ? "-" : format(",.0f")(val);
    }
  }
};
</script>

<style scoped>
.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "" !important;
}
</style>
